await loadComponent('./components/mc-element.js', false);

class AnchorLink extends McElement {
  connectedCallback() {
    this.addEventListener("click", this.link.bind(this));
  }

  link = () => {
    const target = document.querySelector(this.dataset.target);
    if(!target) {
      console.error("AnchorLink: No target found");
      return;
    }
    const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--h-header').trim().replace('px', '')) || 0;

    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = rect.top + scrollTop - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

if (!customElements.get('anchor-link')) {
  customElements.define('anchor-link', AnchorLink);
}
window.AnchorLink = AnchorLink;
